class DelayedInput extends Component {
    constructor(props) {
        super(props)

        this.onChange = this.onChange.bind(this)
        this.update = this.update.bind(this)
        this.onBlur = this.onBlur.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
        this.startUpdating = this.startUpdating.bind(this)
        this.callbackOnUpdate = this.callbackOnUpdate.bind(this)

        this.state = {
            value: props.value,
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value)
            this.setState({
                value: nextProps.value,
                isDirty: false,
            })
    }

    onChange(event) {
        this.setState(
            {
                value: event.target.value,
                isDirty: true,
            },
            this.startUpdating
        )
    }

    update() {
        if (this.state.isDirty)
            this.setState(
                {
                    isDirty: false,
                },
                this.callbackOnUpdate
            )
    }

    onBlur() {
        this.update()
    }

    onKeyPress(event) {
        if (event.key === 'Enter' && !this.props.isTextArea) {
            this.update()
        }
    }

    startUpdating() {
        if (!this.props.updateAutomatically) return

        clearTimeout(this.state.timer)

        this.setState({
            timer: setTimeout(this.update, 1000),
        })
    }

    callbackOnUpdate() {
        this.props.onUpdate(this.state.value)
    }

    render() {
        // eslint-disable-next-line no-unused-vars
        const { isTextArea, updateAutomatically, onUpdate, inputRef, ...props } = this.props
        const TextField = isTextArea ? 'textarea' : 'input'

        return (
            <TextField
                {...props}
                value={this.state.value || ''}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onKeyPress={this.onKeyPress}
                ref={inputRef}
            />
        )
    }
}

DelayedInput.propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    onUpdate: PropTypes.func,
    isTextArea: PropTypes.bool,
}

DelayedInput.defaultProps = {
    value: '',
    placeholder: '',
    isTextArea: false,
    updateAutomatically: true,
    onUpdate: () => {},
}

export default DelayedInput
